import script from "./TicketCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketCard.vue?vue&type=script&setup=true&lang=js"

import "./TicketCard.vue?vue&type=style&index=0&id=629870fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-629870fa"]])

export default __exports__